export default __webpack_public_path__ + "static/media/854.1a8a2f68.gif";